<div class="d-flex align-items-center justify-content-between mb-4">
    <h6 class="montserrat-medium text-gray-500">Start by choosing a title for your campaign</h6>
    <button
        class="btn btn-lg btn-gray-500"
        [disabled]="!form.valid"
        type="submit"
        form="createCampaignForm"
        *ngIf="!previewMode && !partialEditMode && !liveEditMode"
    >
        <span *ngIf="!campaign">start planning</span>
        <span *ngIf="campaign">proceed</span>
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    </button>
</div>

<div class="d-xl-flex align-items-start justify-content-between">
    <div class="flex-grow-1 mx-xl-3">
        <div class="bg-gray-200 br-15 p-3">
            <form
                name="form"
                [formGroup]="form"
                id="createCampaignForm"
                (ngSubmit)="createCampaign()"
            >
                <div class="row">
                    <ng-template #textField let-field>
                        <div [class]="field.cols">
                            <mat-form-field class="form-group dark-input big-input"
                                [ngClass]="{ validationError: hasError(field.name) }">
                                <input matInput [formControlName]="field.name" [type]="field.type"
                                    [placeholder]="field.placeholder" />
                            </mat-form-field>
                            <app-error-input [form]="form" [controlName]="field.name"></app-error-input>
                        </div>
                    </ng-template>

                    <ng-container *ngFor="let field of topFields"
                        [ngTemplateOutlet]="textField"
                        [ngTemplateOutletContext]="{ $implicit: field }">
                    </ng-container>
                    <div class="col-lg-6 mb-4">
                        <div class="montserrat-medium text-gray mb-3">Select your buying model</div>
                        <div class="col-12">
                            <mat-radio-group
                                aria-label="campaign_billing_method"
                                formControlName="campaign_billing_method"
                            >
                                <mat-radio-button value="PER_HOUR" class="mr-4">
                                    <span class="d-flex align-items-center justify-content-center">
                                        Per Hour (CPH)
                                    </span>
                                </mat-radio-button>
                                <mat-radio-button value="PER_IMPRESSION">
                                    <span class="d-flex align-items-center justify-content-center">
                                        Per Impression (CPM) - UAE only
                                    </span>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="col-12 montserrat-medium text-gray mb-3">
                        Select your industry type and campaign location. You can choose multiple
                        countries
                    </div>
                    <div class="col-12 col-lg-6">
                        <mat-form-field class="form-group dark-input">
                            <mat-label>Industry</mat-label>

                            <input
                                type="text"
                                matInput
                                formControlName="industry"
                                [matAutocomplete]="auto" 
                                #trigger="matAutocompleteTrigger"
                                (click)="trigger.openPanel()"
                            />

                            <mat-icon matSuffix 
                                    (click)="trigger.openPanel()" 
                                    class="autocomplete-arrow">
                                expand_more
                            </mat-icon>

                            <mat-autocomplete
                                #auto="matAutocomplete"
                                [displayWith]="displayIndustryName"
                                (optionSelected)="onIndustrySelected($event.option.value)"
                                panelClass="select-panel-down"
                            >
                                <mat-option
                                    *ngFor="let industry of filteredIndustries"
                                    [value]="industry.idIndustry"
                                    class="text-capitalize"
                                >
                                    {{ industry.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>

                        <app-error-input [form]="form" [controlName]="'industry'">
                        </app-error-input>
                    </div>
                    <ng-container *ngFor="let field of issuerFields"
                        [ngTemplateOutlet]="textField"
                        [ngTemplateOutletContext]="{ $implicit: field }">
                    </ng-container>

                    <div class="col-12 mb-2" *ngIf="showTermsAcceptance">
                        <div class="d-flex align-items-start terms-acceptance">
                            <mat-checkbox
                                formControlName="terms_accepted"
                                [disableRipple]="true"
                                [ngClass]="{ validationError: hasError('terms_accepted') }"
                                aria-label="Agree to the Terms & Conditions and Privacy Policy"
                            ></mat-checkbox>
                            <span class="montserrat-medium text-gray ml-2">
                                Please agree to our
                                <a [routerLink]="['/terms-and-conditions']" target="_blank">
                                    Terms &amp; Conditions
                                </a>
                                and our
                                <a [routerLink]="['/privacy-policy']" target="_blank">
                                    Privacy Policy
                                </a>
                                before planning your campaign.
                            </span>
                        </div>
                        <app-error-input [form]="form" [controlName]="'terms_accepted'">
                        </app-error-input>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
